import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class RuteadorService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerCamionChoferDisponible(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($rutEmpresa: Decimal, $editar: Boolean, $unidad_negocio_codigo: Decimal, $fecha: Date, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            ruteador {
              obtenerCamionChoferDisponible(
                rutEmpresa: $rutEmpresa
                editar: $editar
                unidad_negocio_codigo: $unidad_negocio_codigo
                fecha: $fecha
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    patente
                    chofer_rut
                    recorrido_codigo
                    descripcion_camion
                    fecha
                    nombre_chofer
                    peso_maximo_camion
                    volumen_maximo_camion
                    total_facturas
                    camion_activo
                    chofer_activo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.ruteador.obtenerCamionChoferDisponible;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDetalleCamionChofer(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($recorrido_codigo: Decimal, $excel: Boolean) {
            ruteador {
              obtenerDetalleCamionChofer(recorrido_codigo: $recorrido_codigo, excel: $excel) {
                respuesta {
                  registros {
                    recorrido_codigo
                    rut_emisor
                    numero_documento
                    tipo_documento
                    total_documentos
                    cliente_proveedor_rut
                    latitud
                    longitud
                    nombre_cliente
                    peso
                    volumen
                    cajas
                    direccion_completa
                    comuna_despacho
                    vendedor_nombre
                    rutaArchivo
                    estado
                    fecha_emision_folio
                    unidad
                    prioridad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.ruteador.obtenerDetalleCamionChofer;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDetalleCamionChoferpdf(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($recorrido_codigo: Decimal, $retornaPDF: Boolean) {
            ruteador {
              obtenerDetalleCamionChofer(recorrido_codigo: $recorrido_codigo, retornaPDF: $retornaPDF) {
                respuesta {
                  registros {
                    recorrido_codigo
                    rut_emisor
                    numero_documento
                    tipo_documento
                    total_documentos
                    cliente_proveedor_rut
                    latitud
                    longitud
                    nombre_cliente
                    peso
                    volumen
                    cajas
                    direccion_completa
                    comuna_despacho
                    vendedor_nombre
                    rutaArchivo
                    estado
                    fecha_emision_folio
                    prioridad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.ruteador.obtenerDetalleCamionChofer;
            callback({ mensajes, respuesta });
        });
    }
    obtenerCamionChofer(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($estado: String, $fechaDesde: String, $fechaHasta: String, $unidad_negocio_codigo: Decimal) {
            ruteador {
              obtenerCamionChofer(estado: $estado, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, unidad_negocio_codigo: $unidad_negocio_codigo) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    patente
                    nombre_chofer
                    chofer_rut
                    total_facturas
                    total_documentos
                    recorrido_codigo
                    despachado
                    fecha
                    peso_maximo_camion
                    volumen_maximo_camion
                    peso_maximo_recorrido
                    volumen_maximo_recorrido
                    diferencia_peso
                    diferencia_volumen
                    estado
                    total_bultos
                    codigo_estado
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.ruteador.obtenerCamionChofer;
            callback({ mensajes, respuesta });
        });
    }
    //* OBTENER DOCUMENTOS EN EL RUTEADOR MANUAL - "NO EN EL RUTEADOR CON MAPA"
    obtenerDocumentosbyFiltros(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $unidad_negocio_codigo: Decimal
            $fechaDesde: String
            $fechaHasta: String
            $estado: Decimal
            $rut_empresa: Decimal
            $comuna_codigo: [Decimal]
            $vendedor_codigo: [Decimal]
            $territorio_codigo: [Decimal]
          ) {
            ruteador {
              obtenerDocumentosbyFiltros(
                unidad_negocio_codigo: $unidad_negocio_codigo
                fechaDesde: $fechaDesde
                fechaHasta: $fechaHasta
                estado: $estado
                rut_empresa: $rut_empresa
                comuna_codigo: $comuna_codigo
                vendedor_codigo: $vendedor_codigo
                territorio_codigo: $territorio_codigo
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rut_emisor
                    rut_receptor
                    folio
                    comuna
                    longitud
                    latitud
                    direccion_completa
                    direccion_codigo
                    ruta_codigo
                    vendedor
                    territorio
                    tipo_dte_codigo
                    vendedor_codigo
                    comuna_codigo
                    territorio_codigo
                    cliente_proveedor_rut
                    folio_recorrido_Detalle
                    fecha_emision
                    total_peso
                    total_volumen
                    total_cantidad
                    total_unidad
                    total_monto
                    nombre_cliente
                    estado_cliente
                    estado
                    caja
                    fraccion
                    recorrido_codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.ruteador.obtenerDocumentosbyFiltros;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTotalesAsignacion(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($lista: [documentoJoinInputType]) {
            ruteador {
              obtenerTotalesAsignacion(lista: $lista) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rut_emisor
                  rut_receptor
                  folio
                  comuna
                  longitud
                  latitud
                  direccion_completa
                  direccion_codigo
                  ruta_codigo
                  vendedor
                  territorio
                  tipo_dte_codigo
                  vendedor_codigo
                  comuna_codigo
                  territorio_codigo
                  cliente_proveedor_rut
                  folio_recorrido_Detalle
                  fecha_emision
                  total_peso
                  total_volumen
                  total_cantidad
                  total_unidad
                  total_monto
                  nombre_cliente
                  estado_cliente
                  estado
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.ruteador.obtenerTotalesAsignacion;
            callback({ mensajes, respuesta });
        });
    }
    obtenerResumenDocumentos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($unidad_negocio_codigo: Decimal, $fechaDesde: String, $fechaHasta: String, $estado: Decimal, $rut_empresa: Decimal, $comuna_codigo: [Decimal], $vendedor_codigo: [Decimal], $territorio_codigo: [Decimal]) {
            ruteador {
              obtenerResumenDocumentos(unidad_negocio_codigo: $unidad_negocio_codigo, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, estado: $estado, rut_empresa: $rut_empresa, comuna_codigo: $comuna_codigo, vendedor_codigo: $vendedor_codigo, territorio_codigo: $territorio_codigo) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    total_documentos
                    documentos_entregados
                    documentos_pendientes
                    numeros_clientes
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.ruteador.obtenerResumenDocumentos;
            callback({ mensajes, respuesta });
        });
    }
    despacharRecorrido(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: camion_choferJoinInputType) {
            ruteador {
              modificar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  recorrido_codigo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.ruteador.modificar;
            callback({ mensajes, respuesta });
        });
    }
    asignacionAutomatica(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($listadoDocumentos: [recorrido_detalleInputType], $listadoRecorridos:[camion_choferJoinInputType]) {
            recorrido_detalle {
              agregarListaRecorridoAutomaticaDetalle(listadoDocumentos: $listadoDocumentos, listadoRecorridos:$listadoRecorridos) {
                respuesta {
                  recorrido_codigo
                  status
                  message
                }
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.recorrido_detalle.agregarListaRecorridoAutomaticaDetalle;
            callback({ mensajes, respuesta });
        });
    }
    guardarPrioridades(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
       mutation ($entidad: camion_choferJoinInputType) {
        ruteador {
          guardarPrioridad(entidad: $entidad) {
            mensajes{
              codigo
              contexto
              texto
              tipo
            }
          }
        }
      }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.ruteador.guardarPrioridad;
            callback({ mensajes, respuesta });
        });
    }
}
RuteadorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RuteadorService_Factory() { return new RuteadorService(i0.ɵɵinject(i1.GraphQLClient)); }, token: RuteadorService, providedIn: "root" });
